import React from 'react';
import { BsFillFileEarmarkCheckFill } from 'react-icons/bs';
import { FaPills, FaHospital, FaMoneyBillWave } from 'react-icons/fa';

const AwaitingPaymentComponent = () => {
    return (
        <div className="p-4 sm:p-6">
            {/* Header Section */}
            <div className="mb-6">
                <div className="flex items-center gap-3 mb-2">
                    <FaMoneyBillWave className="text-blue-500 text-2xl" />
                    <h2 className="text-xl font-semibold text-gray-800">Awaiting Payment</h2>
                </div>
                <p className="text-sm text-gray-600">Your invoice has been sent and is awaiting payment confirmation</p>
            </div>

            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
                <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                        <BsFillFileEarmarkCheckFill className="text-blue-500 text-3xl" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">Payment Pending</h3>
                    <p className="text-gray-600 max-w-md">
                        Your invoice has been successfully generated and sent. We'll notify you once the payment is received.
                    </p>
                    <div className="mt-6 flex items-center gap-4 text-sm text-gray-500">
                        <div className="flex items-center gap-2">
                            <FaPills className="text-blue-500" />
                            <span>Order Processed</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaHospital className="text-blue-500" />
                            <span>Invoice Sent</span>
                        </div>
                        <div className="w-8 h-px bg-gray-200"></div>
                        <div className="flex items-center gap-2">
                            <FaMoneyBillWave className="text-blue-500" />
                            <span>Awaiting Payment</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AwaitingPaymentComponent;
